import {
	ADMINADDORUPDATEKYCPROOF_SUCCESS,
	ADMINADDORUPDATEKYCPROOF_FAILED,
	RESET_ADMINADDORUPDATEKYCPROOF,
	LOADING_ADMINADDORUPDATEKYCPROOF,
	NETWORK_ERROR_ADMINADDORUPDATEKYCPROOF
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminAddOrUpdateKycProof = () => {
	return { type: RESET_ADMINADDORUPDATEKYCPROOF };
};

const adminAddOrUpdateKycProof =
	(userData, authTokenIs) => async (dispatch) => {
		dispatch({ type: LOADING_ADMINADDORUPDATEKYCPROOF });
		await adminServices
			.post("createOrUpdateKycProofType", userData, { headers: { AuthToken: authTokenIs } })
			.then((res) => {
				switch (res.data.status) {
					case "success":
						dispatch(adminAddOrUpdateKycProofsuccess(res.data));
						break;
					default:
						dispatch(adminAddOrUpdateKycProofFailed(res.data));
						break;
				}
			})
			.catch((err) => {
				dispatch({
					type: NETWORK_ERROR_ADMINADDORUPDATEKYCPROOF,
					payload: err
				});
			});
	};
function adminAddOrUpdateKycProofsuccess(data) {
	return {
		type: ADMINADDORUPDATEKYCPROOF_SUCCESS,
		payload: data
	};
}
function adminAddOrUpdateKycProofFailed(data) {
	return {
		type: ADMINADDORUPDATEKYCPROOF_FAILED,
		payload: data
	};
}

export { resetAdminAddOrUpdateKycProof, adminAddOrUpdateKycProof };
